'use client';

import { useEffect, useRef, useState } from "react";
import styles from "./ua.module.scss";
import ListingWithFilters from "@/partials/vehicles/ListingWithFilters";
import { strings } from "@/utils/I18n";

export default function InventoryList(props) {
  
  const site = props.site;
  
  const [filters,setFilters] = useState(props.site.inventory?.filters)
  
  const listing = useRef()
  
  useEffect(() => {
  }, [])
  
  return (
    <div>
      <div className={styles.inv}>
        { !props.site.page?.budget_widget_expanded &&
        <section className={ styles.invflttop }></section>
        }
        <section>
          <ListingWithFilters ref={listing} {...props} withSearch={true} inventory={ props.inventory } filters={filters} searchPlaceholder={strings(props.site)['global_srpSearchPh']}></ListingWithFilters>
        </section>
      </div>
    </div>
    
  )
  
}
